// DashboardPage.jsx
import React, { useEffect, useMemo, useRef, useState } from 'react';

// code for Scada  Layout  29 Jan 2026
import "./ScadaCSS.css";
import "./SCADAHOMECSS.css";
import { useNavigate } from "react-router-dom";
import { isToday } from "date-fns";

import ReactDOM from 'react-dom';
import DynamicSTPChart from './DynamicSTPChart';
import ScadaChart from "./ScadaChart.js";

import Map from "@arcgis/core/Map";
import MapView from "@arcgis/core/views/MapView";
import MapImageLayer from "@arcgis/core/layers/MapImageLayer";
import "@arcgis/core/assets/esri/themes/light/main.css";
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import Query from "@arcgis/core/rest/support/Query";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import Graphic from "@arcgis/core/Graphic";
import { useSearchParams } from "react-router-dom";


import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid,
  Tooltip, Legend, ResponsiveContainer
} from "recharts";


//Layers
const baseURL = "https://urbangis.mp.gov.in/server"
// Layer definitions
const mainLayerUrl = "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer";


const SummaryCard = ({ title, value, unit, limit, mad }) => {
  const numericValue = parseFloat(value);
  let isOverLimit = false;

  if (title === "pH") {
    // pH special case: range 5.5–9
    const min = 5.5;
    const max = 9;
    isOverLimit =
      !isNaN(numericValue) && (numericValue < min || numericValue > max);
  } else {
    const numericLimit = parseFloat(limit);
    isOverLimit =
      !isNaN(numericValue) && !isNaN(numericLimit) && numericValue > numericLimit;
  }

  return (
    <div className={`card ${isOverLimit ? "card-danger" : ""}`}>
      <div className="card-header">
        <span className="card-title">{title}</span>
      </div>
      <div className="card-value" style={{ color: "white" }}>
        {value} <span className="card-unit">{unit}</span>
      </div>
      <div className="card-footer">
        <span>
          {title === "pH" ? limit : `Limit Max: ${limit}`}
        </span>
       
      </div>
    </div>
  );
};


const DashboardPage = () => {
  // later you can replace inletConfig/outletConfig with API-driven state
  // const [inletData, setInletData] = React.useState(inletConfig);
  // const [outletData, setOutletData] = React.useState(outletConfig);

const [searchParams] = useSearchParams();
 const siteid = searchParams.get("siteid");


// AUTO CALL LOOP
// const siteIds = Array.from({ length: 31 }, (_, i) => i + 1);
//   const [siteId, setSiteId] = useState(siteIds[0]);
  const [ulbName, setUlbName] = useState("Lodding...."); // store ULB name from API
   const [DeviceName, setDeviceName] = useState("Lodding...."); 
  const [point, setPoint] = useState({ type: "point", latitude: 0, longitude: 0 });



  // Call API whenever siteId changes
  useEffect(() => {

    fetchScadaData(siteid);
  }, [siteid]);
 // Start / manage interval



// AUTO CALL LOOP

const [LiveData, setLiveData] = useState([]);
//  CODE FOR FETCH DTS


const fetchScadaData = async (siteId) => {
        try {

            const response = await fetch(
                "https://urbangis.mp.gov.in/api/Station_Data/GetScadaDataSitewise",
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ distCd: null, ulbCd: null, siteId: siteId }),
                }
            );
            if (!response.ok) throw new Error("Failed to fetch data");
            const res = await response.json();
            setLiveData(res.data || res || []);    
          
               
        } catch (error) {
            console.error("Error fetching SCADA data:", error);
        } finally {
           // setLoading(false);
        }
    };

//  ULB DATA 
 // Extract ulbName from LiveData

  useEffect(() => {
    if (Array.isArray(LiveData) && LiveData.length > 0) {
      const stationData = LiveData.find(item => item.stationName === "STP_OUTLET");
      setUlbName(stationData?.ulB_Name || "Station not found");
      setDeviceName(stationData?.deviceName || "Station not found");
         

    } else {
      setUlbName("Loading...");
    }
  }, [LiveData]);
// ULB DATA 

 // CODE FOR MAP
  const layerRef = useRef(null);
  const [map, setMap] = useState(null);
  const mapDiv = useRef(null);
  const [view, setView] = useState(null);

useEffect(() => {
  if (!mapDiv.current) return;

  const map = new Map({ basemap: "topo-vector" });

  const mapView = new MapView({
    container: mapDiv.current,
    map,
    center: [77.4126, 23.2599],
    zoom: 5,
    ui: { components: ["attribution"] }
  });

  const layer = new MapImageLayer({ url: mainLayerUrl, sublayers: [] });

  const adminLayer = new MapImageLayer({
    url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/MapServer",
    sublayers: [
      { id: 1, visible: true },
      { id: 3, visible: true }
    ]
  });

  // graphics layer for pins
  const graphicsLayer = new GraphicsLayer();
  map.addMany([adminLayer, layer, graphicsLayer]);

  // ----- ADD PIN HERE -----
  // Use LiveData for dynamic lat/lon
  const point = {
    type: "point",
    longitude: LiveData?.[0]?.longitude || 79.920045, // fallback if data missing
    latitude: LiveData?.[0]?.latitude || 23.209810
  };
  
// BHUPEN CODE TO CHECK ONLINE OFFLINE

const checkStationOffline = (stationName) => {
  const stationData = LiveData.find(
    item => item.stationName === stationName
  );

  const hasNoData =
    stationData?.cod == null &&
    stationData?.bod == null &&
    stationData?.tss == null;

  const isOldRecord =
    !stationData?.recordDateTime ||
    !isToday(new Date(stationData.recordDateTime));

  return hasNoData || isOldRecord;
};

const isOutletOffline = checkStationOffline("STP_OUTLET");
const isInletOffline = checkStationOffline("STP_INLET");

// If ANY one is offline
const isOffline = isOutletOffline || isInletOffline;


 const markerSymbol = {
  type: "simple-marker",
  color: isOffline ? [255, 0, 0, 1] : [0, 255, 0, 1],
  outline: {
    color: [255, 255, 255, 1],
    width: 1
  }
};



// BHUPEN CODE TO CHECK ONLINE OFFLINE

  const pointGraphic = new Graphic({
    geometry: point,
    symbol: markerSymbol,
    attributes: { name: "My Location" },
    popupTemplate: {
      title: `"DeviceName": "${LiveData?.deviceName}"`,
      content: `Lon: ${point.longitude}, Lat: ${point.latitude}`
    }
  });

  graphicsLayer.add(pointGraphic);
  // -------------------------

  layerRef.current = layer;
  setView(mapView);

  // BLINK: hide/show every 500 ms
  let visible = true;
  const blinkInterval = setInterval(() => {
    visible = !visible;
    pointGraphic.visible = visible;
  }, 100);

  return () => {
    clearInterval(blinkInterval); // stop blinking on unmount
    if (mapView) mapView.destroy();
  };
}, [LiveData]); // <--- dependency: updates pin when LiveData changes


  // CODE FOR MAP
  // CODE FOR BACK TO SCADA
  const navigate = useNavigate();
  const handleBackToClick = (row) => {
       //  alert(`BACK TO SCADA Tools`);
       //  navigate("/dashboard");
          navigate("/dashboard?type=13");
    };

  // CODE FOR BACK TO SCADA

  return (
    <div className="page">
      {/* LEFT SIDE: INLET & OUTLET BLOCKS */}
      <div className="left-column"> 
       <div className="left-column">

  {/* ================= INLET BLOCK ================= */}
  {(() => {
    const stationData = LiveData.find(item => item.stationName === "STP_INLET");
  // code for LIVE AND OFFLINE
    const isToday = (date) => {
    if (!date) return false;

  const today = new Date();
  const recordDate = new Date(date);

  return (
    recordDate.getDate() === today.getDate() &&
    recordDate.getMonth() === today.getMonth() &&
    recordDate.getFullYear() === today.getFullYear()
  );
};

const isOffline =
  (
    stationData?.cod == null &&
    stationData?.bod == null &&
    stationData?.tss == null
  ) ||
  !isToday(stationData?.recordDateTime);


// CODE FOR LIVE AND OFFLINE

    return (
      <div className="block">

       <div className="status-bar">
  <div>
        <span
  className={`status-live ${isOffline ? "offline" : ""}`}
  style={{
    fontSize: "15px",
    fontWeight: "bold",   
    borderRadius: "4px",   
    display: "inline-block",
    background: "#7636d6",
    color: "#fff",
    boxShadow: "0 0 8px rgba(0,0,0,0.3)"
  }}
>
{stationData?.siteId} - <span className="status-title">{stationData?.stationName}

    </span>
</span>
 <center>
      <span className="status-title">{stationData?.deviceName}</span>
    </center>

<span
  className={`status-live ${isOffline ? "offline" : ""}`}
  style={{
    fontSize: "22px",
    fontWeight: "bold",
    padding: "6px 14px",
    borderRadius: "20px",
    marginLeft: "10px",
    display: "inline-block",
    background: isOffline ? "#d50000" : "#00c853",
    color: "#fff",
    boxShadow: "0 0 8px rgba(0,0,0,0.3)"
  }}
>
  {isOffline ? "OFFLINE" : "LIVE"}
</span>

  </div>

 <div className="row-container">
  <div className="status-badge">
     {stationData?.recordDateTime
      ? new Date(stationData.recordDateTime).toLocaleString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit"
        })
      : "No Date Available"}
  </div>
   
</div>
</div>


        <div className="cards-grid">
          <SummaryCard
            title="COD"
            value={stationData?.cod ?? "No Data"}
            unit="mg/L"
            limit="1500"
            />

          <SummaryCard
            title="BOD"
            value={stationData?.bod ?? "No Data"}
            unit="mg/L"
            limit="300"           
          />
          <SummaryCard
            title="TSS"
            value={stationData?.tss ?? "No Data"}
            unit="mg/L"
            limit="300"
           
          />
          <SummaryCard
            title="pH"
            value={stationData?.ph ?? "No Data"}
            unit="pH"
            limit="Limit Max: 9 | Min: 5.5"
           
          />
          <div className="card">
            <div className="card-header">
              <span className="card-title">FLOW</span>
            </div>
            <div className="card-value card-no-data">
              <center>
                {stationData?.flow ?? "No Data"}
              </center>            
            </div>
                <span className="card-title">........</span>
          </div>
          <div className="card">
            <div className="card-header">
              <span className="card-title">TOTALFLOW</span>
            </div>
            <div className="card-value card-no-data">
              {stationData?.flow_Total ?? "No Data"}
            </div>
             <span className="card-title">........</span>
          </div>
        </div>
      </div>
    );
  })()}


  {/* ================= OUTLET BLOCK ================= */}

  {(() => {
    const stationData = LiveData.find(item => item.stationName === "STP_OUTLET");  
  // code for LIVE AND OFFLINE
const isToday = (date) => {
  if (!date) return false;

  const today = new Date();
  const recordDate = new Date(date);

  return (
    recordDate.getDate() === today.getDate() &&
    recordDate.getMonth() === today.getMonth() &&
    recordDate.getFullYear() === today.getFullYear()
  );
};

const isOffline =
  (
    stationData?.cod == null &&
    stationData?.bod == null &&
    stationData?.tss == null
  ) ||
  !isToday(stationData?.recordDateTime);

  // CODE FOR LIVE AND OFFLINE


    return (
      <div className="block">
       <div className="status-bar">
   <div>
        <span
  className={`status-live ${isOffline ? "offline" : ""}`}
  style={{
    fontSize: "15px",
    fontWeight: "bold",   
    borderRadius: "4px",   
    display: "inline-block",
    background: "#7636d6",
    color: "#fff",
    boxShadow: "0 0 8px rgba(0,0,0,0.3)"
  }}
>
  {stationData?.siteId} - <span className="status-title">{stationData?.stationName}

    </span>
</span>
 <center>
      <span className="status-title">{stationData?.deviceName}</span>
    </center>

<span
  className={`status-live ${isOffline ? "offline" : ""}`}
  style={{
    fontSize: "22px",
    fontWeight: "bold",
    padding: "6px 14px",
    borderRadius: "20px",
    marginLeft: "10px",
    display: "inline-block",
    background: isOffline ? "#d50000" : "#00c853",
    color: "#fff",
    boxShadow: "0 0 8px rgba(0,0,0,0.3)"
  }}
>
  {isOffline ? "OFFLINE" : "LIVE"}
</span>

  </div>
<div className="row-container">
  <div className="status-badge">
     {stationData?.recordDateTime
      ? new Date(stationData.recordDateTime).toLocaleString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit"
        })
      : "No Date Available"}
  </div>   
</div>
</div>
        <div className="cards-grid">
          <SummaryCard
            title="COD"
            value={stationData?.cod ?? "No Data"}
            unit="mg/L"
            limit="50"           
          />
          <SummaryCard
            title="BOD"
            value={stationData?.bod ?? "No Data"}
            unit="mg/L"
            limit="10"           
          />
          <SummaryCard
            title="TSS"
            value={stationData?.tss ?? "No Data"}
            unit="mg/L"
            limit="10"           
          />
          <SummaryCard
            title="pH"
            value={stationData?.ph ?? "No Data"}
            unit="pH"
            limit="Limit Max: 9 | Min: 6.5"           
          />

          <div className="card">
            <div className="card-header">
              <span className="card-title">FLOW</span>
            </div>
            <div className="card-value card-no-data">
              {stationData?.flow ?? "No Data"}
            </div>
             <span className="card-title">........</span>
          </div>

          <div className="card">
            <div className="card-header">
              <span className="card-title">TOTALFLOW</span>
            </div>
            <div className="card-value card-no-data">
              {stationData?.flow_Total ?? "No Data"}
            </div>
             <span className="card-title">........</span>
          </div>
        </div>
      </div>
    );
  })()}
</div>
      </div>
      {/* RIGHT SIDE: INFO + MAP */}
      <div className="right-column">
        <div className="info-header">               
            <button className="labeBack" style={{marginTop: "5px", marginRight: "5px", float: "right" ,
            height:"30px",borderRadius: "4px",}} 
             onClick={handleBackToClick}>Back </button>           
       <div className="labelULB">
          <div style={{ marginBottom: "10px" }}>ULB Name: {ulbName}</div>         
            <div className="label">  <h6>    ADDRESS :    {DeviceName}  </h6>  </div>           
           </div>        
        </div>
        <div className="map-card">
          <div className="map-placeholder">
            <div ref={mapDiv}
              style={{
                width: "100%",
                height: 'calc(100vh - 560px)',
                overflow: "hidden",
              }}
            >
            </div>
          </div>
           ReactDOM.render(<DynamicSTPChart LiveData={LiveData} />, document.getElementById('root'));
        </div>
        {/* <div className="info-footer">
          <div>
            <div className="label">Capacity</div>
            <div>......, ...., ...</div>
            <div className="label">......</div>
            <div>INFRASTRUCTURE</div>
            <div className="label">Installation Type</div>
            <div>IN-SITU</div>
            </div>
          <div>
            <div className="label">Contact Details</div>
            <div>Number:9876543210</div>
            <div>Email: STP32mldstp@gmail.com</div>
          </div>
        </div> */}
      </div>


{/* BOTTOM: TREND SECTION */}
      <div className="bottom-section">
     ReactDOM.render(<ScadaChart  />, document.getElementById('root'));
      

{/* import React from 'react';
import ReactDOM from 'react-dom';
import DynamicSTPChart from './DynamicSTPChart'; */}

   {/* <div className="chart-card">
    <div className="chart-header">COD</div>
      <div style={{ width: '100%', height: 420 }}>
      <ResponsiveContainer>
        <BarChart data={data}>
        <CartesianGrid stroke="#ccc" strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="inlet"   fill="#eb2943"  name="Inlet" />
          <Bar dataKey="outlet"  fill="#80e5f1" name="Outlet" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  </div> */}
      </div>
    </div>
  );
};
export default DashboardPage;